export default __webpack_public_path__ + "static/media/InstantDownloadCheck.28a368fa.svg";